export const common = {
  // Header
  "header.solutions": "Lösungen",
  "header.about": "Über uns", 
  "header.testimonials": "Referenzen",
  "header.contact": "Kontakt",
  "header.getStarted": "Loslegen",
  
  // Hero Section
  "hero.slide1.title": "Optimieren Sie Abläufe mit Intelligenter KI",
  "hero.slide1.subtitle": "Optimieren Sie Ihre industriellen Prozesse mit modernsten KI-Agenten und steigern Sie Effizienz und Produktivität in den gesamten Vereinigten Staaten.",
  "hero.slide2.title": "KI-Gestützte Industrielle Exzellenz", 
  "hero.slide2.subtitle": "Transformieren Sie Ihre Fertigungsprozesse mit intelligenter Automatisierung und prädiktiver Analyse.",
  "hero.slide3.title": "Intelligente Digitale Lösungen",
  "hero.slide3.subtitle": "Nutzen Sie die Kraft von agentischer KI für fortschrittliche Automatisierungssysteme und intelligente industrielle Abläufe.",
  "hero.optimizeWithAI": "Mit KI Optimieren",
  "hero.learnMore": "Mehr erfahren",
  
  // About Section
  "about.title": "Industrien mit KI-Innovation Stärken",
  "about.paragraph1": "Bei AiCH stehen wir an der Spitze der Transformation industrieller Landschaften durch fortschrittliche KI-Agenten. Mit Sitz in den Vereinigten Staaten ist es unsere Mission, die operative Effizienz und Innovation in verschiedenen Sektoren zu verbessern.",
  "about.paragraph2": "Unsere hochmodernen Lösungen integrieren sich nahtlos in bestehende Systeme und treiben Wachstum und Nachhaltigkeit voran. Schließen Sie sich uns an, während wir die Zukunft der Industrie mit Intelligenz und Einfallsreichtum gestalten.",
  
  // Values Section
  "values.badge": "Industrie Verbessern",
  "values.title": "KI-Innovation für Industrielles Wachstum",
  "values.subtitle": "Stärkung von Industrien mit hochmodernen KI-Lösungen, die Fortschritt vorantreiben, Effizienz steigern und nachhaltiges Wachstum in den gesamten Vereinigten Staaten fördern.",
  "values.innovation.title": "Innovation",
  "values.innovation.description": "Bei AiCH setzen wir uns dafür ein, die Grenzen der Technologie zu erweitern. Unser Team erforscht kontinuierlich neue Grenzen in der KI, um hochmoderne Lösungen zu liefern, die Industrien stärken.",
  "values.integrity.title": "Integrität",
  "values.integrity.description": "Wir glauben daran, unser Geschäft mit höchstem Maß an Ehrlichkeit und Transparenz zu führen. Unsere Kunden vertrauen uns, zuverlässige und ethische KI-Lösungen zu liefern, die Erfolg vorantreiben.",
  "values.collaboration.title": "Zusammenarbeit",
  "values.collaboration.description": "Teamarbeit steht im Mittelpunkt von allem, was wir tun. Wir fördern eine kollaborative Umgebung, in der vielfältige Ideen gedeihen und zu kreativen Lösungen und gemeinsamen Erfolg führen.",
  "values.excellence.title": "Exzellenz",
  "values.excellence.description": "Unser Streben nach Exzellenz treibt uns an, überlegene Produkte und Dienstleistungen zu liefern. Wir widmen uns der Erreichung höchster Standards in allem, was wir tun, um Qualität und Wert für unsere Kunden zu gewährleisten.",
  "values.sustainability.title": "Nachhaltigkeit",
  "values.sustainability.description": "AiCH setzt sich für nachhaltige Praktiken ein, die sowohl unseren Kunden als auch dem Planeten zugute kommen. Wir streben danach, KI-Lösungen zu schaffen, die nicht nur effektiv, sondern auch umweltverträglich sind.",
  
  // Solutions Section
  "solutions.badge": "Effizienz Entfesselt",
  "solutions.title": "Optimieren Sie Effizienz mit Fortschrittlicher KI",
  "solutions.subtitle": "Steigern Sie die Produktivität mit hochmodernen KI-Lösungen, die für industrielle Anwendungen maßgeschneidert sind und beispielloses Wachstum und operative Exzellenz vorantreiben.",
  "solutions.predictiveMaintenance.title": "Prädiktive Wartung",
  "solutions.predictiveMaintenance.description": "Nutzen Sie KI, um Geräteausfälle vorherzusagen und Ausfallzeiten zu reduzieren.",
  "solutions.processOptimization.title": "Prozessoptimierung",
  "solutions.processOptimization.description": "Verbessern Sie die operative Effizienz durch KI-gestützte Erkenntnisse.",
  "solutions.qualityControl.title": "Qualitätskontroll-Automatisierung", 
  "solutions.qualityControl.description": "Implementieren Sie KI, um konsistente Produktqualität sicherzustellen und Defekte zu reduzieren.",
  "solutions.supplyChain.title": "Lieferketten-Effizienz",
  "solutions.supplyChain.description": "Optimieren Sie Logistik und Lagerverwaltung mit KI-Analysen.",
  "solutions.energyManagement.title": "Energiemanagement",
  "solutions.energyManagement.description": "Reduzieren Sie den Energieverbrauch durch KI-Überwachung und -Anpassung der Nutzung.",
  "solutions.safetyMonitoring.title": "Sicherheitsüberwachung",
  "solutions.safetyMonitoring.description": "Verbessern Sie die Arbeitsplatzsicherheit mit KI-gestützter Überwachung und Warnungen.",
  
  // Testimonials Section
  "testimonials.badge": "Bewiesene Wirkung",
  "testimonials.title": "Hören Sie von Unseren Partnern", 
  "testimonials.subtitle": "AiCHs innovative KI-Lösungen haben unsere Abläufe transformiert, die Effizienz gesteigert und beispielloses Wachstum vorangetrieben. Sehr empfehlenswert!",
  "testimonials.jordan.content": "AiCH hat unsere Abläufe mit seinen hochmodernen KI-Lösungen revolutioniert. Effizienz und Produktivität sind in die Höhe geschnellt und ermöglichen es uns, uns auf strategisches Wachstum zu konzentrieren.",
  "testimonials.alex.content": "AiCHs KI-Agenten haben die Effizienz und Innovation unseres Arbeitsablaufs transformiert. Ihre Expertise in industrieller KI ist unübertroffen und bietet uns strategische Einblicke und nachhaltiges Wachstum.",
  "testimonials.taylor.content": "Die Partnerschaft mit AiCH war transformativ für uns. Ihre KI-gestützten Lösungen haben unsere Prozesse optimiert und sowohl Effizienz als auch Innovation gesteigert. Es ist ein Spielwechsler für jede Industrie.",
  
  // CTA Section
  "cta.title": "Transformieren Sie Ihre Industrie Heute",
  "cta.subtitle": "Erschließen Sie beispiellose Effizienz und Innovation mit AiCHs fortschrittlichen KI-Lösungen, die für Industrieführer maßgeschneidert sind. Heben Sie Ihre Abläufe an und bleiben Sie auf dem wettbewerbsintensiven Markt vorne.",
  "cta.exploreSolutions": "Lösungen Erkunden",
  "cta.scheduleDemo": "Demo Planen",
  
  // Language Switcher
  "language.select": "Sprache"
};

export default {
  ...common,
  cta: {
    title: 'Bereit, Ihre Branche zu Transformieren?',
    subtitle: 'Schließen Sie sich führenden Unternehmen an, die KI nutzen, um Innovation und Effizienz voranzutreiben. Lassen Sie uns besprechen, wie unsere Lösungen Ihrem Unternehmen zugutekommen können.',
    exploreSolutions: 'Lösungen Erkunden',
    scheduleDemo: 'Demo Planen'
  },
  demo: {
    title: 'Demo Planen',
    subtitle: 'Füllen Sie das untenstehende Formular aus und unser Team wird sich in Kürze mit Ihnen in Verbindung setzen, um eine personalisierte Demonstration zu vereinbaren.',
    name: 'Vollständiger Name',
    namePlaceholder: 'Geben Sie Ihren vollständigen Namen ein',
    email: 'E-Mail-Adresse',
    emailPlaceholder: 'Geben Sie Ihre E-Mail ein',
    company: 'Firmenname',
    companyPlaceholder: 'Geben Sie Ihren Firmennamen ein',
    phone: 'Telefonnummer',
    phonePlaceholder: 'Geben Sie Ihre Telefonnummer ein',
    message: 'Zusätzliche Informationen',
    messagePlaceholder: 'Erzählen Sie uns von Ihren Bedürfnissen und Interessen...',
    submit: 'Anfrage Senden',
    submitting: 'Wird gesendet...',
    cancel: 'Abbrechen',
    successMessage: 'Vielen Dank! Ihre Demo-Anfrage wurde erfolgreich übermittelt. Wir werden uns bald bei Ihnen melden.',
    errorMessage: 'Entschuldigung, beim Senden Ihrer Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.'
  }
};
